import { Button, Flex, Modal, Spinner } from '@wyz/ui';
import { invariant } from '@wyz/utils';
import Markdown from 'react-markdown';
import { useAuth } from 'react-oidc-context';
import { useManageUsers } from '~/common/api';
import { Trans } from '~/common/context';
import { useManageLegalPages } from '~/connect/api';

const TermsOfUseConsentModal = () => {
  const manageLegalPages = useManageLegalPages({
    getTermsOfUse: { enabled: true },
  });

  const auth = useAuth();
  const manageUsers = useManageUsers({
    acceptTermsOfUse: { enabled: true },
  });

  return (
    <Modal.Container
      open
      onClose={() => {}}
      backdrop={'static'}
      keyboard={false}
      fullscreen
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Trans i18nKey='app.common.legal_informations.terms_of_use' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body data-cy='confirmation-modal'>
        <div>
          {!manageLegalPages.getTermsOfUse.isSettled && <Spinner />}
          {manageLegalPages.getTermsOfUse.isSuccess && (
            <div>
              <Markdown>{manageLegalPages.getTermsOfUse.data.data}</Markdown>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Flex className='w-100 space-x-4'>
          <Button
            id='submit-modal-consent'
            variant={'primary'}
            isLoading={manageUsers.acceptTermsOfUse.isLoading}
            type='submit'
            onClick={() => {
              invariant(auth.user?.profile.sub);
              manageUsers.acceptTermsOfUse.mutate({
                id: auth.user?.profile.sub,
              });
            }}
            fullWidth
          >
            <Trans i18nKey='app.common.cookie_consent.accept_button' />
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal.Container>
  );
};

export default TermsOfUseConsentModal;
